import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Lock, Loader2, ArrowLeft } from "lucide-react";
import { adminLogin } from "../lib/api";
import { toast } from "sonner";
import { BRAND } from "../lib/constants";

export default function AdminLogin() {
  const [pw, setPw] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (!pw) return;
    setLoading(true);
    try {
      const { token } = await adminLogin(pw);
      localStorage.setItem("gd_admin_token", token);
      toast.success("Welcome back, admin");
      navigate("/admin");
    } catch {
      toast.error("Invalid password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white flex flex-col gd-stripes-dark" data-testid="admin-login-page">
      <div className="border-b border-white/10 px-5 md:px-10 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3" data-testid="admin-login-home">
          <img src={BRAND.logo} alt="" className="h-8 w-auto bg-white p-0.5" />
          <span className="font-display font-black tracking-tight">GigDrive<span className="text-[#E60012]">.</span></span>
        </Link>
        <Link to="/" className="gd-tag text-white/50 hover:text-white inline-flex items-center gap-2">
          <ArrowLeft size={14} /> Site
        </Link>
      </div>

      <div className="flex-1 flex items-center justify-center px-5 py-16">
        <form onSubmit={submit} className="bg-[#0A0A0A] border-2 border-white/20 p-8 md:p-10 w-full max-w-md" data-testid="admin-login-form">
          <div className="w-12 h-12 bg-[#E60012] flex items-center justify-center mb-6">
            <Lock size={20} strokeWidth={2.5} />
          </div>
          <div className="gd-tag text-[#E60012] mb-3">▌ Admin Access</div>
          <h1 className="font-display font-black text-3xl md:text-4xl tracking-tighter mb-2 uppercase">Operator login</h1>
          <p className="text-white/50 text-sm mb-8">Restricted to GigDrive ops team.</p>

          <label className="gd-tag text-white/70 mb-2 block">Password</label>
          <input
            type="password"
            value={pw}
            onChange={(e) => setPw(e.target.value)}
            placeholder="••••••••"
            className="w-full bg-black border-2 border-white/30 px-4 py-3 font-mono text-sm focus:outline-none focus:border-[#E60012] mb-6"
            data-testid="admin-password-input"
            autoFocus
          />

          <button
            type="submit"
            disabled={loading}
            className="w-full font-display font-black uppercase tracking-wider py-4 bg-[#E60012] text-white border-2 border-[#E60012] hover:bg-white hover:text-black hover:border-white gd-snappy inline-flex items-center justify-center gap-2 disabled:opacity-60"
            data-testid="admin-login-btn"
          >
            {loading ? <><Loader2 size={16} className="animate-spin" /> Authenticating...</> : "Enter Dashboard"}
          </button>

          <p className="font-mono text-[10px] text-white/30 mt-6 text-center">SECURE SESSION · NO COOKIES STORED</p>
        </form>
      </div>
    </div>
  );
}
